export const INTER = 'Inter';
export const SOURCE_SERIF_PRO = 'Source Serif Pro';
export const WORK_SANS = 'Work Sans';
export const IBM_PLEX_SANS = 'IBM Plex Sans';
export const BARLOW = 'Barlow';
export const MONTSERRAT = 'Montserrat';
export const ROBOTO_SLAB = 'Roboto Slab';
